<template>
	<div id="usre-baseinfor" class="oh" >
		<!-- 政府端 -->
		<leftnav class="fl" mkcode="E" itemcode="E-WDGXW" :title="title"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader></govheader>
			<div class="index_left_centerpage"> 
			<div class="whitebox right_topbox calculatorResult" style="min-height: 800px;">
					<div class="right_boxtitle">
						<span class="fl right_title">计算结果</span> 
						<span class="fr rightlink curp" @click="routerself('/userrelational')">我的关系网</span>
					</div>
					<div>
						<!-- <div class="titlebox">
							<h5 class="box1">我熟悉的企业</h5>
							<h5 class="box2">中间企业</h5>
							<h5 class="box3">我想联系的企业</h5>
						</div>
						<ul > 
							<li v-for="list in resultslist" >
								<div class="box1"><span class="title" :data-d="list.relation[0].stockCode" @click="routerlinkid('/enterprises',list.relation[0].stockCode)">{{list.relation[0].title}}</span></div>
								<div class="box2">
									<p class="arrowline"v-if="list.length == 3"> 
										<span class="arrowpng"> <em class="">{{list.relation[1].type}}</em></span>
										<span class="title contitle" :data-d="list.relation[1].stockCode" @click="routerlinkid('/enterprises',list.relation[1].stockCode)">{{list.relation[1].title}}</span> 
										<span class="arrowpng "> <em class="">{{list.relation[2].type}}</em></span>
									</p>
									<p class="arrowline" v-if="list.length == 2">
										<span class="arrowpng1 "><em class="con">供应商</em></span> 
									</p>
								</div>
								<div class="box3">
									<span class="title" v-if="list.length == 2" :data-d="list.relation[1].stockCode"  @click="routerlinkid('/enterprises',list.relation[1].stockCode)">{{list.relation[1].title}}</span>
									<span class="title" v-if="list.length == 3":data-d="list.relation[2].stockCode" @click="routerlinkid('/enterprises',list.relation[2].stockCode)">{{list.relation[2].title}}</span>
									</div>
							</li> 
						</ul> -->
						<table border="0" cellspacing="0" cellpadding="0"  class="pagetable1" width="100%" >
							<tr>
								<th style="width: 300px;">我熟悉的企业</th>
								<th colspan="3">中间关系</th>
								<th style="width: 300px;">我想联系的企业</th>
							</tr>
							<tr :key="i"  v-for="(list,i) in resultslist" v-if="list.length == 3" v-show="list.relation[2].stockCode == resultdata.target">
							<td class="title" @click="routerlinkid('/enterprises',list.relation[0].stockCode)">{{list.relation[0].title}}</td>
							<td style="width: 200px;" class="tac">
							<!-- ({{list.relation[1].type}}) -->
							<span v-if="list.relation[1].type == '供应商'" class="relationship-arrow">客户——供应商</span>
							<span v-if="list.relation[1].type == '客户'" class="relationship-arrow">供应商——客户</span>
							<span v-if="list.relation[1].type == '投资'" class="relationship-arrow">投资——融资</span>
							<span v-if="list.relation[1].type == '融资'" class="relationship-arrow">融资——投资</span>
							<span v-if="list.relation[1].type == '子公司'" class="relationship-arrow">母公司——子公司</span>
							<span v-if="list.relation[1].type == '母公司'" class="relationship-arrow">子公司——母公司</span>
							<span v-if="list.relation[1].type == '母公司'" class="relationship-arrow">子公司——母公司</span>
							<span v-if="list.relation[1].type == '投资机构'" class="relationship-arrow"><em>被投企业——投资机构</em></span>
							<span v-if="list.relation[1].type == '商会'" class="relationship-arrow"><em>成员——商会</em></span>
							<span v-if="list.relation[1].type == '协会'" class="relationship-arrow"><em>成员——协会</em></span>
							</td>
							<td style="width: 300px;" class="title" @click="routerlinkid('/enterprises',list.relation[1].stockCode)">{{list.relation[1].title}}</td>
							<td style="width: 200px;" class="tac">
						 <!-- ({{list.relation[2].type}}) -->
							<span v-if="list.relation[2].type == '供应商'" class="relationship-arrow">客户——供应商</span>
							<span v-if="list.relation[2].type == '客户'" class="relationship-arrow">供应商——客户</span>
							<span v-if="list.relation[2].type == '投资'" class="relationship-arrow">投资——融资</span>
							<span v-if="list.relation[2].type == '融资'" class="relationship-arrow">融资——投资</span>
							<span v-if="list.relation[2].type == '子公司'" class="relationship-arrow">母公司——子公司</span>
							<span v-if="list.relation[2].type == '母公司'" class="relationship-arrow">子公司——母公司</span>
							<span v-if="list.relation[2].type == '被投企业'" class="relationship-arrow"><em>投资机构——被投企业</em></span>
							<span v-if="list.relation[2].type == '商会成员'" class="relationship-arrow"><em>商会——成员</em></span>
							<span v-if="list.relation[2].type == '协会成员'" class="relationship-arrow"><em>协会——成员</em></span>
							</td>
							<td class="title" @click="routerlinkid('/enterprises',list.relation[2].stockCode)">{{list.relation[2].title}}</td>
						</tr>
						<tr :key="i"  v-for="(list,i) in resultslist" v-if="list.length == 2">
							<td class="title" @click="routerlinkid('/enterprises',list.relation[0].stockCode)">{{list.relation[0].title}}</td>
							<td colspan="3" class="tac">
							<!-- ({{list.relation[1].type}}) -->
							<span v-if="list.relation[1].type == '客户'" class="relationship-arrow">客户————————————————供应商</span>
							<span v-if="list.relation[1].type == '供应商'" class="relationship-arrow">供应商————————————————客户</span>
							<span v-if="list.relation[1].type == '投资'" class="relationship-arrow">投资————————————————融资</span>
							<span v-if="list.relation[1].type == '融资'" class="relationship-arrow">融资————————————————投资</span>
							<span v-if="list.relation[1].type == '子公司'" class="relationship-arrow">母公司————————————————子公司</span>
							<span v-if="list.relation[1].type == '母公司'" class="relationship-arrow">子公司————————————————母公司</span>
							</td>
							<td class="title" @click="routerlinkid('/enterprises',list.relation[1].stockCode)">{{list.relation[1].title}}</td>
						</tr>
						</table>
					</div> 
			</div> 
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'calculatorResult',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				userdata:{}, 
				title:'计算结果',
				editbtn:false,id:0,
				// 计算器结果data存值分割线
				resultslist:[{relation:[{stockCode:"",title:""}]}],guideid:"",resultdata:{sourceList:"",target:""},saveresultbtn:true,
			}},
		 created() {
		 	this.userdata=this.getuseriformation(); 
				this.id = this.$route.query.id;  
		 },
			mounted() {
				this.bus.$emit('loading', false);
				 this.resultdetail(this.id);
			},
			methods:{  
				resultdetail(id){
					var _this=this;
					this.$axios.get(this.$api.cyl.enterpriseRelation.detail()+'?id='+id, {headers: {AuthToken: this.userdata.token}
					}).then(function(res) {
						if(res.data.success){
						console.log('查看结果', res.data); 
					 _this.resultslist=res.data.list;
					 _this.resultdata=res.data.data;
							_this.bus.$emit('loading', false);
						} else {
							
						}
					}).catch(function(error) {console.log(error)});
				},
			}
	}  
</script>

<style scoped>
	 
</style>
